"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgLogoutIcon = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  ...props,
  children: (0, jsx_runtime_1.jsxs)("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(-200 -1643)",
    children: [(0, jsx_runtime_1.jsx)("rect", {
      id: "Bold_2px_logout_background",
      "data-name": "Bold 2px/logout background",
      width: "16",
      height: "16",
      transform: "translate(200 1643)",
      fill: "none"
    }), (0, jsx_runtime_1.jsxs)("g", {
      id: "Group",
      transform: "translate(202 1644.333)",
      children: [(0, jsx_runtime_1.jsx)("path", {
        id: "Union",
        d: "M5.529.2a.667.667,0,0,0,0,.943l1.2,1.2H.667a.667.667,0,1,0,0,1.333H6.724l-1.2,1.2a.667.667,0,0,0,.943.943L8.333,3.943a1.333,1.333,0,0,0,0-1.886L6.471.2A.667.667,0,0,0,5.529.2Z",
        transform: "translate(3.333 3.667)"
      }), (0, jsx_runtime_1.jsx)("path", {
        id: "Vector_587_Stroke_",
        "data-name": "Vector 587 (Stroke)",
        d: "M2,0H6A2,2,0,0,1,8,2v.667a.667.667,0,1,1-1.333,0V2A.667.667,0,0,0,6,1.333H2A.667.667,0,0,0,1.333,2v9.333A.667.667,0,0,0,2,12H6a.667.667,0,0,0,.667-.667v-.667a.667.667,0,1,1,1.333,0v.667a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
      })]
    })]
  })
});
exports.default = SvgLogoutIcon;